// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkComponent_link__1iucT","icon":"LinkComponent_icon__edDBE"};